import { number, object, string } from 'yup';

export const dateSchema = object().shape({});
export const keySchema = string();
export const positionSchema = number().min(0);
